import { useEffect } from 'react';

const reloadConfirm = () => 'Are you sure you want to reload the page.';

export const ReloadPageNotification = () => {
  useEffect(() => {
    window.onbeforeunload = reloadConfirm;
  }, []);

  useEffect(() => {
    return () => {
      window.onbeforeunload = () => undefined;
    };
  }, []);

  return null;
};
